module.exports = __webpack_public_path__ + "assets/img/vartojimas.b30b6582.jpg";